import { writable } from 'svelte/store'

export const artPanelState = writable('categories')

export const artCategoryId = writable()

export const artSelectionId = writable()
